import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import { composedAPI } from "./api";
import subscriberGroupComposition from "./composition";
import help from "help/viewSubscriberGroupProfileConfig.md";
import settingsHelp from "help/viewSubscriberGroupProfileConfigSettings.md";

const ConfigSubscriberGroupProfiles = ({ ...settings }) => (
  <ProfilesAndSettings
    {...subscriberGroupComposition}
    {...composedAPI}
    {...settings}
    help={help}
    settingsHelp={settingsHelp}
  />
);

export default ConfigSubscriberGroupProfiles;
